import { voices } from "@/mocks/voices";

export default function VoicesGrid() {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-5">
      {voices.map((voice) => (
        <figure
          key={voice.name}
          className="h-full rounded-lg bg-secondary-50 border border-secondary-200/70 p-5 md:p-6"
        >
          <i className="ri-double-quotes-l text-2xl text-secondary-400"></i>
          <blockquote className="mt-3 text-sm md:text-base text-foreground-700 leading-relaxed">
            {voice.quote}
          </blockquote>
          <figcaption className="mt-5 flex items-center gap-3 pt-4 border-t border-secondary-200/70">
            <span className="w-9 h-9 flex items-center justify-center rounded-full bg-secondary-500 text-background-50 font-heading font-bold text-sm">
              {voice.name.slice(0, 1)}
            </span>
            <span className="flex flex-col">
              <span className="font-label text-sm font-medium text-foreground-900">
                {voice.name}
              </span>
              <span className="text-xs text-foreground-500 font-label">
                {voice.role}
              </span>
            </span>
          </figcaption>
        </figure>
      ))}
    </div>
  );
}